import * as React from 'react';
import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import { productPageUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import { LangText } from './LangText';

export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale = 'us', pathname } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);

    const buyLink = React.useMemo(() => `https://${locale}.ecoflow.com/products/delta-3-classic-portable-power-station`, [locale]);

    const dataA: EcoNavProductProps = {
        productItems: [
            {
                value: 'name1',
                label: TextA.product_name,
                // href: thePageUrl,
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'Bundles',
                label: TextA.tab_bundles,
                href: isInProductPage ? undefined : `${thePageUrl}?tab=Bundles`,
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                href: `${thePageUrl}/specs`,
            },
            {
                value: 'Support',
                label: TextA.tab_support,
                href: `${thePageUrl}/support`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: TextA.btn_buy,
                href: buyLink,
            },
        ],
        theme: locale === 'us' ? 'black' : 'white',
    };
    const tabChange = (item: any, index: number) => {
        if (tabCallback) {
            tabCallback(item.value);
        }
    };

    const buyChange = () => {
        saveCookieForShopify(buyLink, locale);
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} onBuyChange={buyChange} />
        </div>
    );
}
